import { NgModule } from "@angular/core";
import { CommonModule } from "@angular/common";
import { VolumePricePipe } from "./volume-price.pipe";



@NgModule( {
	declarations: [
		VolumePricePipe
	],
	imports: [
		CommonModule
	],
	exports: [
		VolumePricePipe
	]
} )

export class VolumePriceModule { }
